<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">You will need:</p>

      <ul class="default-list">
        <li>
          A word-processing program (such as Microsoft Word, Google Docs, TextEdit or Notebook) or
          paper with a pen/pencil to write a script
        </li>
        <li>A recording device such as a laptop or phone with a camera and/or a microphone</li>
        <li>A friend or family member willing to be your student</li>
      </ul>

      <ol class="numbered-list">
        <li>
          Choose an activity that you really enjoy. It could be a dance, a meal you like to cook, or
          an exercise.
        </li>
        <li>
          Make a draft script for your lesson on how to do that activity. It might help to think
          about it like you’re writing a recipe. Think about:<br /><br />
          What equipment does the student need to do the activity?<br />
          What ideas need explanation before they start the activity?
        </li>
        <li>
          Take another look at the section on the ‘Basic Principles of Teaching’. In this case,
          you’re looking to model the activity - so now is the time to record yourself showing how
          to perform the activity you’ve chosen.<br /><br />
          An extra tip is to think about using the metacognition skill - talk through what you are
          doing and why you’re doing it as you make your way through the activity.
        </li>
        <li>
          Once you’re done recording the video or audio, show it to your ‘student’, and see if
          they’re able to complete the activity based on what you’ve shown them without your
          additional construction.
        </li>
        <li>
          If they run into any obstacles, make edits and additions to your script with that feedback
          in mind. Remember to not be hard on yourself if you didn’t get it 100% right the first
          time - a lot of activities we enjoy doing are based on knowledge and skills that we have
          that we take for granted.
        </li>
        <li>Once you’ve re-recorded the lesson, upload it to the VJE portal!</li>
      </ol>

      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="media"
        index="1"
        key="1"
      />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      login_type: localStorage.getItem('login_type'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
